<!-- Itens selecionados -->
<div *ngIf="showCheckboxes" class="selected-items__container">
  <div *ngIf="countSelectedItems > 0" class="div-selected-items">
    <h5 class="text-ent">
      {{
        capitalize(lextranslate.i18n["46af3fe5-a60d-45cb-8adf-92d420b91f4f"])
      }}:
    </h5>
    <button
      class="btn btn-success selected-items"
      (click)="openModalSelectedItems()"
    >
      <span
        [innerHTML]="lextranslate.i18n['9280715a-785c-4b5e-9d1a-0c95e5f2ab0a']"
      >
      </span>
    </button>
    <div class="div-clear-filter-button div-clear-selected-button">
      <div style="position: relative">
        <button
          type="button"
          class="clear-filter-button clear-selected-button"
          [ngbTooltip]="
            lextranslate.i18n['46116210-6d98-4758-b107-cfc777c4603b']
          "
          placement="bottom"
          (click)="clearAllSelectedItems()"
        >
          <em class="material-icons">delete_sweep</em>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="lex-table mt-2" [ngClass]="{ 'table-limited': inModal }">
  <div class="lex-table-header">
    <div
      class="lex-table-row"
      [ngStyle]="{ padding: showStatus ? '16px 24px 16px 0px' : '' }"
    >
      <div
        class="lex-table-column"
        *ngFor="let column of columns; let indexColumn = index"
        [ngStyle]="{
          width:
            (showStatus && column.id === 'status') ||
            (showCheckboxes && column.id === 'checkboxes') ||
            column.actionButton
              ? '35px'
              : showStatus && column.id === 'statusWithWarning'
              ? '175px'
              : column.width,
          padding:
            (showStatus && column.id === 'status') ||
            (showCheckboxes && column.id === 'checkboxes')
              ? '0  0 0 16px'
              : showStatus && column.id === 'statusWithWarning'
              ? '0px'
              : showStatus && indexColumn === 2
              ? '0 24px 0 16px'
              : column.actionButton || column.id === 'icon'
              ? '0'
              : '',
          paddingRight:
            (column.foldable &&
              column.foldable.content === 'foldableProduct') ||
            column.id === 'icon'
              ? 0
              : '',
          minWidth:
            column.actionButton && readonly && column.id === 'deleteButton'
              ? '0px'
              : column.name
              ? '150px'
              : '',
          textAlign: column.actionButton ? 'end' : ''
        }"
      >
        <!-- Texto simples do header -->
        <span
          *ngIf="
            !column.ordination &&
            column.id !== 'deleteButton' &&
            column.id !== 'actionButtonGroup'
          "
          [ngStyle]="column.ngStyle || ''"
          >{{ column.name }}</span
        >

        <span
          *ngIf="
            !column.ordination && column.id === 'deleteButton' && !readonly
          "
          [ngStyle]="column.ngStyle || ''"
        >
          {{ column.name }}</span
        >

        <!-- Column action button-->
        <span
          *ngIf="
            !column.ordination && column.id === 'actionButtonGroup' && !readonly
          "
          [ngStyle]="column.ngStyle || ''"
          >{{ column.name }}
          <i
            class="foldable-content__more"
            [ngClass]="'tooltip-action-button-lex-table'"
            *ngIf="column.showtooltipIcon"
            data-toggle="popover"
            data-html="true"
            [attr.data-content]="column.tooltipText"
            data-container="body"
            data-placement="left"
            data-trigger="hover"
            class="sidebar-item-icon material-icons"
            >help</i
          >
        </span>

        <!-- Componente de ordenação -->
        <seb-table-order
          *ngIf="column.ordination"
          [sLabel]="column.name"
          [nIndex]="column.ordination.orderType"
          (click)="onSortColumn(column)"
        >
        </seb-table-order>

        <!-- Checkbox para a seleção de todos os itens -->
        <div
          *ngIf="showCheckboxes && column.id === 'checkboxes'"
          class="d-flex"
        >
          <label class="checkbox checkbox-outline-primary">
            <input
              type="checkbox"
              [ngModel]="areAllSelected"
              (change)="toggleAllSelection()"
            />
            <span class="input-span"></span>
          </label>
        </div>
      </div>
    </div>
  </div>

  <div
    class="lex-table-content"
    [hidden]="preloader"
    [ngClass]="{
      readonly: readonly,
      'table-limited-body': inModal,
      'table-historic-user': tableHistoric,
      'disable-line-click': disableLineClick
    }"
  >
    <div
      class="lex-table-row"
      *ngFor="let d of data; let indexData = index"
      [ngStyle]="{
        backgroundColor: indexData % 2 !== 0 ? '#f9f9f9' : '#fff',
        borderRadius: indexData === data.length - 1 ? '0 0 5px 5px' : '',
        paddingLeft: showStatus ? 0 : '',
        border: rowSelect
          ? itemSelected == d.id
            ? '2px solid #68bfac'
            : '1px solid #ddd'
          : ''
      }"
      (click)="!disableLineClick ? redirectToItemEdit($event, d) : null"
    >
      <div
        class="lex-table-column"
        *ngFor="let column of columns; let indexColumn = index"
        [ngStyle]="{
          width:
            (showStatus && column.id === 'status') ||
            (showCheckboxes && column.id === 'checkboxes') ||
            column.actionButton
              ? '40px'
              : showStatus && column.id === 'statusWithWarning'
              ? '175px'
              : column.width,
          padding:
            (showStatus && column.id === 'status') ||
            (showCheckboxes && column.id === 'checkboxes')
              ? '0 0 0 16px'
              : showStatus && indexColumn === 2
              ? '0 24px 0 16px'
              : column.actionButton || column.id === 'icon'
              ? 0
              : showStatus && column.id === 'statusWithWarning'
              ? '0px'
              : '',
          overflow: column.foldable ? 'inherit' : '',
          paddingRight:
            (column.foldable &&
              column.foldable.content === 'foldableProduct') ||
            column.actionButton ||
            column.id === 'icon'
              ? 0
              : '',
          minWidth:
            column.actionButton && readonly && column.id === 'deleteButton'
              ? '0px'
              : column.name
              ? '150px'
              : '',
          textAlign:
            (column.actionButton && column.id === 'deleteButton') ||
            (showStatus && column.id === 'statusWithWarning')
              ? 'end'
              : '',
          margin:
            showStatus &&
            column.id === 'statusWithWarning' &&
            d[column.id].status !== 'pending'
              ? '0px -15px 0px 10px'
              : showStatus &&
                column.id === 'statusWithWarning' &&
                d[column.id].status === 'pending'
              ? '0px -15px 10px 10px'
              : ''
        }"
      >
        <!-- Texto simples do body e contador -->
        <div
          class="d-flex"
          *ngIf="
            (!column.foldable &&
              !column.iconText &&
              column.id !== 'status' &&
              column.id !== 'pendingStatus' &&
              column.id !== 'statusWithWarning' &&
              !column.actionButton &&
              !column.pill &&
              column.id !== 'icon') ||
            column.count
          "
          [ngStyle]="column.ngStyle || ''"
        >
          <span
            *ngIf="
              !column.foldable &&
              column.id !== 'status' &&
              column.id !== 'created' &&
              !column.actionButton &&
              !column.pill
            "
            [title]="d[column.id]"
            class="table-text"
            [ngClass]="d[column.ngClass]"
            >{{ d[column.id] }}</span
          >
          <span *ngIf="column.count" class="span-count"
            >({{ d[column.count] }})</span
          >
          <span *ngIf="column.id == 'created'">{{
            d[column.id] | date: "dd/MM/yyyy HH:mm"
          }}</span>
        </div>

        <!-- Action button -->
        <div
          *ngIf="
            column.actionButton && readonly && column.id === 'deleteButton'
              ? false
              : column.actionButton && !d.hideButtons
          "
          [ngClass]="
            column.actionButton && column.id === 'deleteButton'
              ? 'btn-actionDelete'
              : column.actionButton && column.id === 'viewHistoric'
              ? 'btn-actionView'
              : 'text-center'
          "
        >
          <button
            type="button"
            [title]="
              column.actionButton && column.actionButton.actionTitle
                ? column.actionButton.actionTitle
                : ''
            "
            class="btn btn-primary btn-transparent js-action d-flex align-items-center"
            [ngClass]="
              column.actionButton && column.actionButton.customClass
                ? column.actionButton.customClass
                : ''
            "
            style="padding: 0"
            (click)="callAction($event, column.actionButton.actionId, d)"
            [disabled]="d[column.id] && d[column.id].disabled"
          >
            <i
              aria-hidden="true"
              style="font-size: 28px; pointer-events: none"
              class="sidebar-item-icon material-icons"
              [ngClass]="
                column.actionButton && column.actionButton.customIconClass
                  ? column.actionButton.customIconClass
                  : ''
              "
              >{{ column.actionButton.icon }}</i
            >
          </button>
        </div>

        <!-- Action Group button -->
        <div
          *ngIf="column.actionGroupButton"
          [ngClass]="
            column.actionGroupButton && column.id === 'actionButtonGroup'
              ? 'groupActionButtons'
              : ''
          "
        >
          <button
            id="{{ column.actionGroupButton.actionSettingsId + d.id }}"
            type="button"
            [title]="
              column.actionGroupButton &&
              column.actionGroupButton.actionSettingTitle
                ? column.actionGroupButton.actionSettingTitle
                : ''
            "
            class="btn btn-primary btn-transparent js-action d-flex align-items-center"
            [ngClass]="
              column.actionGroupButton && column.actionGroupButton.customClass
                ? column.actionGroupButton.customClass
                : ''
            "
            style="padding: 0"
            (click)="
              callAction($event, column.actionGroupButton.actionSettingsId, d)
            "
            [disabled]="
              (d[column.id] && d[column.id].disabled) ||
              d[column.disabledSettingButton]
            "
          >
            <i
              aria-hidden="true"
              style="font-size: 28px; pointer-events: none"
              class="sidebar-item-icon material-icons"
              [ngClass]="
                column.actionGroupButton &&
                column.actionGroupButton.customIconEditClass
                  ? column.actionGroupButton.customIconEditClass
                  : ''
              "
              >{{ column.actionGroupButton.iconSetting }}</i
            >
          </button>
          <button
            id="{{ column.actionGroupButton.actionEditId + d.id }}"
            type="button"
            [title]="
              column.actionGroupButton &&
              column.actionGroupButton.actionEditTitle
                ? column.actionGroupButton.actionEditTitle
                : ''
            "
            class="btn btn-primary btn-transparent js-action d-flex align-items-center"
            [ngClass]="
              column.actionGroupButton && column.actionGroupButton.customClass
                ? column.actionGroupButton.customClass
                : ''
            "
            style="padding: 0"
            (click)="
              callAction($event, column.actionGroupButton.actionEditId, d)
            "
            [disabled]="d[column.id] && d[column.id].disabled"
          >
            <i
              aria-hidden="true"
              style="font-size: 28px; pointer-events: none"
              class="sidebar-item-icon material-icons"
              [ngClass]="
                column.actionGroupButton &&
                column.actionGroupButton.customIconEditClass
                  ? column.actionGroupButton.customIconEditClass
                  : ''
              "
              >{{ column.actionGroupButton.iconEdit }}</i
            >
          </button>

          <button
            id="{{ column.actionGroupButton.actionDeleteId + d.id }}"
            type="button"
            [title]="
              column.actionGroupButton &&
              column.actionGroupButton.actionDeleteTitle
                ? column.actionGroupButton.actionDeleteTitle
                : ''
            "
            class="btn btn-primary btn-transparent js-action d-flex align-items-center"
            [ngClass]="
              column.actionGroupButton && column.actionGroupButton.customClass
                ? column.actionGroupButton.customClass
                : ''
            "
            style="padding: 0"
            (click)="
              callAction($event, column.actionGroupButton.actionDeleteId, d)
            "
            [disabled]="
              (d[column.id] && d[column.id].disabled) ||
              d[column.disabledDeleteButton]
            "
          >
            <i
              aria-hidden="true"
              style="font-size: 28px; pointer-events: none"
              class="sidebar-item-icon material-icons"
              [ngClass]="
                column.actionGroupButton &&
                column.actionGroupButton.customIconDeleteClass
                  ? column.actionGroupButton.customIconDeleteClass
                  : ''
              "
              >{{ column.actionGroupButton.iconDelete }}</i
            >
          </button>
        </div>

        <div *ngIf="column.pill">
          <seb-lex-pill
            [ngStyle]="column.pill.styling(d[column.pill.propertyName])"
            >{{
              column.pill.labeling(d[column.pill.propertyName])
            }}</seb-lex-pill
          >
        </div>

        <!-- Imagem  -->
        <div *ngIf="column.iconText" class="text-ellipsis">
          <icon-text
            [iconSrc]="d[column.iconText.propertyName].iconSrc"
            [iconWidth]="column.iconText.iconWidth"
            [forceIcon]="true"
            >{{ d[column.iconText.propertyName].text }}</icon-text
          >
        </div>

        <!-- Foldable component -->
        <foldable-content
          *ngIf="column.foldable"
          [bindLabel]="column.foldable.bindLabel"
          [items]="d[column.foldable.content] || []"
          [ngStyle]="column.foldable.ngStyle"
          [contentWidth]="column.foldable.contentWidth || undefined"
        >
        </foldable-content>

        <div
          *ngIf="
            showStatus &&
            column.id === 'statusWithWarning' &&
            d[column.id].status === 'pending'
          "
          style="font-size: 15px; margin: 10px; font-weight: 600"
        >
          <span
            *ngIf="!d[column.id].newProduct"
            style="color: #ffc566; margin: 10px; position: relative; top: 4px"
            class="material-icons icon-warning"
            [title]="lextranslate.i18n['f6463835-7cc1-41ba-9f35-4cbacedc7ae3']"
            >warning</span
          >
          <abbr
            class="user-status-circle"
            [ngClass]="'user-status-circle--' + d[column.id].colorName"
            title="Pendente"
          ></abbr>
        </div>

        <!-- Warning usado para exbição de status das pendencias -->
        <div
          *ngIf="
            showStatus &&
            column.id === 'pendingStatus' &&
            d[column.id].status === 'pending'
          "
          style="font-size: 15px; margin: 0px; font-weight: 40px"
        >
          <strong
            class="pending-status-row__name-item pending-status-row__warning"
            placement="top"
            [ngbTooltip]="d[column.id].tooltip"
          ></strong>
        </div>

        <abbr
          *ngIf="
            showStatus &&
            column.id === 'statusWithWarning' &&
            d[column.id].status !== 'pending'
          "
          class="user-status-circle"
          [ngClass]="'user-status-circle--' + d[column.id].colorName"
          [title]="d[column.id].label"
        ></abbr>

        <!-- Círculo usado para exbição de status -->
        <abbr
          *ngIf="showStatus && column.id === 'status'"
          class="user-status-circle"
          [ngClass]="'user-status-circle--' + d[column.id].colorName"
          [title]="d[column.id].label"
        ></abbr>

        <!-- Checkboxes para a seleção de um item -->
        <div *ngIf="showCheckboxes && column.id === 'checkboxes'">
          <div class="d-flex">
            <label
              class="checkbox checkbox-outline-primary"
              [ngClass]="{
                'disabled-checkbox': d._checkbox && d._checkbox.disabled,
                'hidden-checkbox': d._checkbox && d._checkbox.hidden
              }"
            >
              <input
                type="checkbox"
                [(ngModel)]="selectedItemsPrimary[d.id]"
                (change)="toggleSelection(d)"
              />
              <span class="input-span"></span>
            </label>
          </div>
        </div>

        <div *ngIf="column.id === 'toggle' && !d.hideButtons">
          <div class="d-flex">
            <div class="checkbox checbox-switch switch-primary">
              <label>
                <input
                  type="checkbox"
                  type="checkbox"
                  [(ngModel)]="d[column.togglePropertyName]"
                  (change)="
                    column.togglePropertyChange && column.togglePropertyChange()
                  "
                />
                <span></span>
              </label>
            </div>
          </div>
        </div>

        <!-- Material icon -->
        <div *ngIf="column.id === 'icon'">
          <span
            class="material-icons"
            [ngStyle]="{ color: d[column.id].color }"
            >{{ d[column.id].name }}</span
          >
        </div>
      </div>
    </div>
    <div class="no-data" *ngIf="data.length === 0">
      {{ noDataText }}
    </div>
  </div>
</div>

<!-- Preloader -->
<seb-preloader
  [preloaderStyle]="{ top: 'auto', marginTop: '32px' }"
  [hidden]="!preloader"
></seb-preloader>

<div
  class="row"
  style="margin-top: 14px; position: relative"
  *ngIf="data.length !== 0"
  [hidden]="preloader"
>
  <!-- Legenda da tabela -->
  <div *ngIf="showSubtitle" class="info-row__column position--lex-table">
    <span class="info-title">{{ subtitle.name }}</span>
    <div style="margin-left: 4px">
      <ul class="statuses-row statuses-row--large-margin">
        <li *ngFor="let content of subtitle.data" [ngStyle]="content.ngStyle">
          <span [ngClass]="content.ngClass"></span> {{ content.label }}
        </li>
      </ul>
    </div>
  </div>

  <!-- Paginação -->
  <div *ngIf="showPagination" class="col-sm-12">
    <seb-table-paggination
      *ngIf="data.length !== 0"
      [nDefault]="initialPage"
      (evIndexPag)="onIndexPag($event)"
      [nItensPerPage]="itemsPerPage"
      [nTamanhoPagination]="paginationSize"
      [notScrollTop]="notScrollTop"
    >
    </seb-table-paggination>
  </div>
</div>
